import React, {useEffect, useState} from "react";
import './index.scss';

import Logo from '../../assets/logos/hot-new.svg';
import CloseIcon from '../../assets/icons/x-close-blue-icon.svg';

import {useSelector} from "react-redux";
import {combineClassNames, getCookie, preventBodyScroll, setCookie} from "../../app/functions";

const AppPopup = props => {
    const [isVisible, setIsVisible] = useState(false);
    const [animationClass, setAnimationClass] = useState('');
    const translations = useSelector((store) => store.config.Translations);
    const {appPopupDebounceDays, enableAppPopup=false} = useSelector((store) => store.config.Parameters);
    const dynamicLink = useSelector(store => store.data.appDynamicLink);
    const deviceState = useSelector(store => store.state.deviceState);
    const isDesktop =  deviceState !== 'mobile' && deviceState !== 'tablet';

    useEffect(() => {
        const shouldShowPopup = getCookie('hot_app_popup') !== 'true';
        if (enableAppPopup && dynamicLink && shouldShowPopup) {
            setIsVisible(true);
        }
    }, [dynamicLink]);

    useEffect(() => {
        if(enableAppPopup && isVisible && !isDesktop) {
            showPopup();
            preventBodyScroll(true);
        } else {
            preventBodyScroll(false);
        }
    }, [isVisible, deviceState]);

    if (!isVisible || isDesktop) {
        return null;
    }

    const showPopup = () => {
        setAnimationClass('show');
    };


    const hidePopup = () => {
        const interval = (60 * 60 * 24 * 1000) * (appPopupDebounceDays ?? 1);
        const now = new Date();
        const expiry = new Date(now.getTime() + interval).toUTCString();
        setCookie('hot_app_popup', true, expiry);
        setAnimationClass('');
        setTimeout(() => {
            setIsVisible(false);
        }, 500);
    };

    return (
        <div className={combineClassNames(
            'app-popup-wrapper',
            animationClass
        )}>
            <div className={'app-popup-backdrop'} onClick={hidePopup}/>
            <div className="app-popup-overlay">
                <img src={Logo} alt={'הוט מועדון צרכנות'} className={'app-popup-logo'} />
                <div className={'app-popup-text'}>{translations['app_popup_text']}</div>
                {dynamicLink && <a href={dynamicLink} onClick={hidePopup} className={'app-popup-button'}>{translations['app_popup_button']}</a>}
                <button className={'app-popup-close-button'} onClick={hidePopup}>
                    <img src={CloseIcon} alt={'אייקון איקס לסגירת הפופאפ'} />
                </button>
            </div>
        </div>
    );
};

export default AppPopup;
